import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact'
import { useState } from 'preact/hooks'
import RangeInput from './elements/RangeInput'

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)

    return (
        <accordion-disclosure class="accordion">
            <details class="accordion__disclosure group" aria-expanded="false">
                <summary>
                    <span class="accordion__toggle h6">
                        <span class="text-with-icon gap-4">{facet.name}</span>
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            fill="none"
                            width="10"
                            class="group-expanded:rotate icon icon-chevron-down"
                            viewBox="0 0 10 10">
                            <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </span>
                </summary>
                <div class="accordion__content">
                    <div class="price-range">
                        <RangeSlider id={facet.id} />
                        <div class="input-group">
                            <label class="input-prefix text-sm">
                                <span class="prefix text-subdued">£</span>
                                <RangeInput
                                    aria-label="From price"
                                    class="field"
                                    autocomplete="off"
                                    id={`ns-${facet.id}-min`}
                                    min={min}
                                    max={max}
                                    range={range}
                                    value={range[0]}
                                    onChange={(e) => {
                                        const value = parseFloat(e.currentTarget.value) || undefined
                                        updateRange([value, range[1]])
                                    }}
                                />
                            </label>

                            <span class="text-subdued text-sm">to</span>

                            <label class="input-prefix text-sm">
                                <span class="prefix text-subdued">£</span>
                                <RangeInput
                                    aria-label="To price"
                                    class="field"
                                    autocomplete="off"
                                    id={`ns-${facet.id}-max`}
                                    min={min}
                                    max={max}
                                    range={range}
                                    value={range[1]}
                                    onChange={(e) => {
                                        const value = parseFloat(e.currentTarget.value) || undefined
                                        updateRange([range[0], value])
                                    }}
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </details>
        </accordion-disclosure>
    )
}
